import {Component, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Product} from './product.model';
import {ProductService} from './product.service';
import {DatatableViewComponent} from '@ngx-ivengi/crud';

@Component({
  selector: 'app-product-overview',
  templateUrl: 'product-overview.component.html'
})
export class ProductOverviewComponent extends DatatableViewComponent<Product> {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  constructor(
    private productService: ProductService,
    private router: UIRouter
  ) {
    super(productService);

    this.requestParams.addSortParam({key: 'productGroup', value: 'asc'});
    this.fetchData();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.productService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('management.product.edit', { productId: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product-overview.component.ts